import classNames from 'classnames/bind';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';

import imageWooflashLogo from 'images/logos/logo.svg';
import Button from 'uikit/Button';
import InputText from 'uikit/InputText';

import LanguageSelector from '../Shared/Container/LanguageSelector';
import ELEPHANT_IMAGE from './images/elephant.svg';
import styles from './RecoverPassword.module.scss';

const cx = classNames.bind(styles);

const RecoverPassword = ({
  defaultEmail,
  handleRecoverPassword,
  isDone,
  t,
  validationSchema,
}) => (
  <div className={cx('container')}>
    <nav className={cx('header')}>
      <Link
        aria-label={t('Shared/MenuContainer/aria-home')}
        className={cx('logo')}
        to="/"
      >
        <img
          alt=""
          aria-hidden="true"
          className={cx('logo-image')}
          src={imageWooflashLogo}
        />
        <span className={cx('logo-text')}>wooflash</span>
      </Link>
      <div className={cx('actions')}>
        <Button
          as={Link}
          className={cx('back')}
          icon="chevron-left"
          intent="white"
          to="/auth/login"
        >
          {t('Auth/RecoverPassword/back')}
        </Button>
        <LanguageSelector />
      </div>
    </nav>
    <img className={cx('elephant')} src={ELEPHANT_IMAGE} alt="" />
    <main className={cx('main')}>
      {isDone ? (
        <>
          <h1 className={cx('title')}>{t('Auth/RecoverPassword/success')}</h1>
          <Button as={Link} intent="primary" size="large" to="/auth/login">
            {t('Auth/RecoverPassword/back')}
          </Button>
        </>
      ) : (
        <Formik
          initialValues={{
            email: defaultEmail,
          }}
          onSubmit={handleRecoverPassword}
          validateOnBlur={false}
          validationSchema={validationSchema}
        >
          {({ isSubmitting, status, values }) => (
            <>
              <Form>
                <h1 className={cx('title')}>
                  {t('Auth/RecoverPassword/title')}
                </h1>
                {status === '404' ? (
                  <p className={cx('error')} role="alert">
                    <Trans i18nKey="Auth/RecoverPassword/recover-password-error-email-not-found">
                      Auth/RecoverPassword/recover-password-error-email-not-found
                      <Link
                        to={{
                          pathname: '/auth/register',
                          state: {
                            email: values.email,
                          },
                        }}
                      >
                        Auth/RecoverPassword/recover-password-error-email-not-found
                      </Link>
                      Auth/RecoverPassword/recover-password-error-email-not-found
                    </Trans>
                  </p>
                ) : (
                  status && (
                    <p className={cx('error')} role="alert">
                      {t('Auth/RecoverPassword/login-error')}
                    </p>
                  )
                )}
                <InputText className={cx('field')} icon="at" name="email" />
                <Button
                  className={cx('recover-button')}
                  intent="primary"
                  isLoading={isSubmitting}
                  size="large"
                  type="submit"
                >
                  {t('Auth/RecoverPassword/recover-password')}
                </Button>
              </Form>
            </>
          )}
        </Formik>
      )}
    </main>
  </div>
);

RecoverPassword.propTypes = {
  defaultEmail: PropTypes.string.isRequired,
  handleRecoverPassword: PropTypes.func.isRequired,
  isDone: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  validationSchema: PropTypes.object.isRequired,
};

export default RecoverPassword;
